import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './counter';
import userIsAuthenticatedReducer from './userIsAuthenticatedReducer';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    userIsAuthenticated: userIsAuthenticatedReducer,
  },
})
